import { Box, VStack, Circle, Text, HStack, Flex } from '@chakra-ui/react';
import getOrderTypeProgress from '~/pages/OrderList/orderTypeProgress';

import { format } from 'date-fns';
import * as fp from 'lodash/fp';

import { OrderType } from '~/types/common';
import { OrderStatus } from '~/types/order';
import { Timestamp } from 'firebase/firestore';
import React from 'react';

type OrderProgressSectionProps = {
  orderType: OrderType;
  status: OrderStatus;
  statusRecord: Partial<Record<OrderStatus, Timestamp>>;
};

export default function OrderProgressSection({
  orderType,
  status,
  statusRecord,
}: OrderProgressSectionProps) {
  const orderProgress = getOrderTypeProgress(orderType);

  return (
    <VStack
      align="stretch"
      p={4}
      spacing={0}
      borderWidth="1px"
      borderColor="gray.400"
      borderRadius="5px"
    >
      {orderProgress.map((progress, index) => {
        const nextStatus = fp.nth(index + 1)(orderProgress);
        const nextRecordTime = nextStatus && statusRecord[nextStatus.status];
        const isActive = fp.eq(progress.status, status);

        return (
          <React.Fragment key={progress.status}>
            {!fp.eq(index, 0) && (
              <Flex px={`${3 / 8}rem`}>
                <Box w="1px" h={4} bgColor="gray.400" />
              </Flex>
            )}
            <Flex justify="space-between" align="center">
              <HStack>
                <Circle
                  w="13px"
                  h="13px"
                  bgColor={isActive ? 'primary' : 'gray.400'}
                  transform={`scale(${isActive ? 1.3 : 1})`}
                />
                <Text
                  fontSize="sm"
                  color={isActive ? 'fontColor' : 'gray.400'}
                  fontWeight={isActive ? 'bold' : 'normal'}
                >
                  {progress.label}
                </Text>
              </HStack>

              {nextRecordTime && (
                <Text fontSize="sm" color="gray.400">
                  {format(nextRecordTime.toDate(), 'HH:mm')}
                </Text>
              )}
            </Flex>
          </React.Fragment>
        );
      })}
    </VStack>
  );
}
